import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls to the top of the page on every route change.
 *
 * React Router v6 doesn't auto-reset scroll position when navigating between
 * routes — by default it keeps the previous page's scroll, which feels broken
 * when you click a link from the bottom of one page and land in the middle of
 * another. Mount this once inside <BrowserRouter> and it fixes the whole app.
 *
 * Skips behavior when navigation has a hash (e.g. /faq#pricing) so anchor
 * links still work.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // let the browser handle in-page anchors
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);

  return null;
}
